export function getQuickBooksInvoiceUrl(externalId: string): string {
  return `https://qbo.intuit.com/app/invoice?txnId=${externalId}`;
}
